<template>
  <v-simple-table
    fixed-header
    :height="height"
    :class="localClass['table']"
    :style="localStyle['table']"
  >
    <template v-slot:default>
      <thead
        :class="localClass['thead']"
        :style="localStyle['thead']"
      >
        <tr>
          <th
            v-for="(field, index) in fieldsLabel" 
            :key="index" 
            :class="localClass['th']"
            :style="localStyle['th']"
          >
            <template v-if="headerPresent">
              <slot :name="headers[index].key + '-header'">
                {{field}}
              </slot>
            </template>
            <template v-else>
              {{field}}
            </template>
          </th>
        </tr>
      </thead>
      <tbody
        :class="localClass['tbody']"
        :style="localStyle['tbody']"
      >
        <tr
          v-for="item in items"
          :key="item[keyField]"
          :class="localClass['tr']"
          :style="localStyle['tr']"
          v-on:click="emit('row-click', item)"
        >
          <td 
            v-for="field in fieldsKey" 
            :key="field"
            :class="localClass['td']"
            :style="localStyle['td']"
          >
            <slot :name="field" v-bind:item="item">
              {{ item[field] }}
            </slot>
          </td>
        </tr>
      </tbody>
    </template>
  </v-simple-table>
</template>

<script>
import emittable from '../../mixins/emittable'

import {
  VSimpleTable,
} from 'vuetify/lib'

const TEXT_ALIGNMENT_MAPPINGS = {
  'start': 'text-left',
  'center': 'text-center',
  'end': 'text-right',
}

export default {
  name: "SimpleTableComponent",
  components: {
    VSimpleTable
  },
  mixins: [emittable],
  data: function() {
    let ls = { ...this.styles }

    let lc = { ...this.classes }
    if(!lc['th']) {
      lc['th'] = {}
    }
    lc['th'][TEXT_ALIGNMENT_MAPPINGS[this.headerTextAlignment]] = true

    return {
      localStyle: ls,
      localClass: lc
    }
  },
  props: {
    color: {
      type: String,
      default: 'primary'
    },
    items: {
      type: Array,
      default: function() {
        return []
      }
    },
    headers: {
      type: Array,
      default: function() {
        return []
      }
    },
    height: {
      type: String,
      default: "100%"
    },
    keyField: {
      type: String,
      default: 'id',
    },
    headerTextAlignment: {
      type: String,
      default: 'start',
      validator: function (value) {
        return ['start', 'center', 'end'].indexOf(value) !== -1
      }
    },
    styles: {
      type: Object,
      default: function () {
        return {
          table: {},
          thead: {},
          tbody: {},
          tr: {},
          td: {},
          th: {}
        };
      },
    },
    classes: {
      type: Object,
      default: function () {
        return {
          table: {},
          thead: {},
          tbody: {},
          tr: {},
          td: {},
          th: {}
        };
      },
    },
  },
  computed: {
    headerPresent() {
      return this.headers.length > 0
    },
    fieldsLabel() {
      if(this.items.length == 0) {
        return []
      } else if (this.headerPresent) {
        return this.headers.map((element) => {return element.label})
      } else {
        return Object.keys(this.items[0])
      }
    },
    fieldsKey() {
      if(this.items.length == 0) {
        return []
      } else if (this.headerPresent) {
        return this.headers.map((element) => {return element.key})
      } else {
        return Object.keys(this.items[0])
      }
    }
  }

}
</script>

<style>

</style>